'use strict';

var util = require('../../util/property-util');
// var $ = require('jquery');

module.exports = /*@ngInject*/ ["$transition", function ($transition) {

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var baseSize = 200;
            var iconSize = 30;
            if(util.isDefined(attrs.baseSize)){
                baseSize = attrs.baseSize;
            }
            if(util.isDefined(attrs.iconSize)){
                iconSize = attrs.iconSize;
            }

            var initialAnimSkip = true;
            var currentTransition;

            function doTransition(change) {
                var newTransition = $transition(element, change);
                if (currentTransition) {
                    currentTransition.cancel();
                }
                currentTransition = newTransition;
                newTransition.then(newTransitionDone, newTransitionDone);
                return newTransition;

                function newTransitionDone() {
                    // Make sure it's this transition, otherwise, leave it alone.
                    if (currentTransition === newTransition) {
                        currentTransition = undefined;
                    }
                }
            }

            function expand() {
                if (initialAnimSkip) {
                    initialAnimSkip = false;
                    expandDone();
                } else {
                    element.removeClass('collapse').addClass('collapsing-width');
                    doTransition({width: baseSize + 'px'}).then(expandDone);
                }
            }

            function expandDone() {
                element.removeClass('collapsing-width');
                element.addClass('collapse in');
                element.css({width: 'auto'});
                var totalSize = Number(baseSize)+Number(iconSize);
                element.parent().parent().parent().css({'min-width': totalSize + 'px'});
                $(window).trigger('resize');
            }

            function collapse() {
                element.parent().parent().parent().css({'min-width': iconSize + 'px'});
                if (initialAnimSkip) {
                    initialAnimSkip = false;
                    collapseDone();
                    element.css({width: 0});
                } else {
                    // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
                    element.css({width: baseSize + 'px'});
                    //trigger reflow so a browser realizes that height was updated from auto to a specific value
                    var x = element[0].offsetHeight;

                    element.removeClass('collapse in').addClass('collapsing-width');

                    doTransition({width: 0}).then(collapseDone);
                }
            }

            function collapseDone() {
                element.removeClass('collapsing-width');
                element.addClass('collapse');
                $(window).trigger('resize');

            }

            scope.$watch(attrs.collapseWidth, function (shouldCollapse) {
                if (shouldCollapse) {
                    collapse();
                } else {
                    expand();
                }
            });
        }
    };
}];